import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { ContentService, SiteContentLocation } from '../../services/content.service';

@Component({
  selector: 'app-location',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="section-padding text-center" *ngIf="content$ | async as content">
      <div class="container">
        <h2 class="title">Find Us</h2>
        <p style="font-size: 1.2rem;">{{ content.address }}</p>
        <p>Email: {{ content.email }} | Phone: {{ content.phone }}</p>
        <hr style="max-width: 200px; margin: 20px auto; border-color: #e5ccbd;" />
        <h3 style="margin-bottom: 15px;">Opening Hours</h3>
        <p *ngFor="let h of content.hours">{{ h.day }}: {{ h.time }}</p>
        <div *ngIf="content.mapEmbed" [innerHTML]="content.mapEmbed" style="margin-top: 30px;"></div>
      </div>
    </div>
  `,
  styles: [`
    .title { color: var(--color-primary-dark); margin-bottom: var(--spacing-sm); }
  `]
})
export class Location implements OnInit {
  content$!: Observable<SiteContentLocation>;

  constructor(private contentService: ContentService) {}

  ngOnInit() {
    this.content$ = this.contentService.getLocationContent();
  }
}
